module.exports = __webpack_public_path__ + "img/mlh_ls4.9fa68e59.png";